module.exports = __webpack_public_path__ + "static/media/icon-2.c3271dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-2.png
// module id = 614
// module chunks = 0